/**
 * Format milliseconds into a human-readable estimated time string.
 * Returns null if ms <= 0 to signal "no estimate available".
 *
 * Examples:
 *   30_000    -> "< 1 min"
 *   300_000   -> "~5 min"
 *   5_400_000 -> "~1h 30min"
 */
export function formatEstimatedTime(ms: number): string | null {
  if (ms <= 0) return null;

  const totalMinutes = Math.round(ms / 60_000);

  if (totalMinutes < 1) return '< 1 min';
  if (totalMinutes < 60) return `~${totalMinutes} min`;

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (minutes === 0) return `~${hours}h`;
  return `~${hours}h ${minutes}min`;
}
